const stickyHeader = () => {
    const currentLang = window.currentLang;
    const windowTop = window.scrollY;
    const header = document.querySelectorAll(`.injected-header .header`);
    const hubnav = document.querySelector('.top-nav');
    if (header) {
        header.forEach((head) => {
        const headerHeight = head.offsetHeight;

        const largeHeader = document.querySelector('.large-header');
        if (largeHeader) {
            const largeHeaderHeight = largeHeader ? largeHeader.offsetHeight : 0;

            if (windowTop > headerHeight) {
                head.classList.add('fixed-header');
                if (hubnav && $('.large-header').is(':visible')) {
                    hubnav.style.setProperty('top', '70px', 'important');
                }
                if (($('#stream-banner-root').is(':visible') || $('.large-header').is(':visible')) && !document.body.classList.contains('hub-page')) {
                    hubnav.style.setProperty('top', '0px', 'important');
                } else {
                    hubnav.style.setProperty('top', '70px', 'important');
                }
            } else {
                head.classList.remove('fixed-header');
            }
        }
    });
    }
};

module.exports = { stickyHeader };


// WEBPACK FOOTER //
// ./scriptPartials/corpHeaderFooter/stickyHeader.js